import Vue from 'vue'
import Store from '@/store/index.js'
import Router from 'vue-router'
import About from '@/pages/about/About'
import Profile from '@/pages/profile/Profile'
import Login from '@/pages/login/Login'
import Join from '@/pages/join/Join'
import Makeqnq from '@/pages/makeqnq/Makeqnq'
import Searchqnq from '@/pages/searchqnq/Searchqnq'
import EditProfile from '@/pages/editprofile/EditProfile'
import Contact from '@/pages/contact/Contact'
import Privacy from '@/pages/privacy/Privacy'
import Teams from '@/pages/teams/Teams'
import Terms from '@/pages/terms/Terms'
import Tree from '@/pages/tree/Tree'
import EditTeam from '@/pages/editteam/EditTeam'
import MyTeams from '@/pages/myteams/MyTeams'
import AboutNode from '@/pages/about/tutorial/AboutNode'
import AboutTeam from '@/pages/about/tutorial/AboutTeam'
import AboutTree from '@/pages/about/tutorial/AboutTree'
import Board from '@/pages/board/Board'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAuth, signInAnonymously, onAuthStateChanged } from 'firebase/auth'
import { signUpQnQ, getMyUserData, getAnonymousData } from '@/api/FirebaseUserWrapper.js'
import * as constant from '@/constant/constant.js'
const DOMAIN_NAME = constant.DEFAULT_DOMAIN_NAME
const auth = getAuth(firebaseApp)

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Searchqnq',
      component: Searchqnq
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        isPublic: true,
        isAnonymous: true
      }
    },
    {
      path: '/about/node',
      name: 'AboutNode',
      component: AboutNode,
      meta: {
        isPublic: true,
        isAnonymous: true
      }
    },
    {
      path: '/about/team',
      name: 'AboutTeam',
      component: AboutTeam,
      meta: {
        isPublic: true,
        isAnonymous: true
      }
    },
    {
      path: '/about/tree',
      name: 'AboutTree',
      component: AboutTree,
      meta: {
        isPublic: true,
        isAnonymous: true
      }
    },
    {
      path: '/profile/:userId',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        isPublic: true,
        isAnonymous: true
      }
    },
    {
      path: '/join/:invitedId',
      name: 'Join',
      component: Join,
      meta: {
        isPublic: true,
        isAnonymous: true
      }
    },
    {
      path: '/makeqnq',
      name: 'Makeqnq',
      component: Makeqnq
    },
    {
      path: '/editprofile',
      name: 'EditProfile',
      component: EditProfile
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: {
        isAnonymous: true
      }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
      meta: {
        isAnonymous: true
      }
    },
    {
      path: '/teams',
      name: 'Teams',
      component: Teams,
      meta: {
        isAnonymous: true
      }
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
      meta: {
        isAnonymous: true
      }
    },
    {
      path: '/tree/:treeId',
      name: 'Tree',
      component: Tree,
      meta: {
        isAnonymous: true
      }
    },
    {
      path: '/editteam/:teamId',
      name: 'EditTeam',
      component: EditTeam
    },
    {
      path: '/myteams',
      name: 'MyTeams',
      component: MyTeams
    },
    {
      path: '/board/:teamId',
      name: 'Board',
      component: Board
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  /* 認証 */
  if (location.hostname !== DOMAIN_NAME) {
    console.log(`beforeEach()`)
    // console.log(`to: ${JSON.stringify(to)}`)
    console.log(`Store: ${JSON.stringify(Store.state)}`)
  }
  // user情報を取得する
  let user = await checkUserAuthState()
  if (!user) {
    /* 未ログインなので匿名ログインする */
    const userData = await signInAnonymously(auth)
    user = userData.user
  }
  if (location.hostname !== DOMAIN_NAME) { console.log(`beforeEach(): user: ${JSON.stringify(user)}`) }
  const isAnonymous = user.isAnonymous
  const userId = user.uid

  /* Storeのユーザ情報と一致しない時はリセットする */
  if (Store.state.user && (Store.state.user.id !== userId)) {
    Store.commit('setUserData', {})
  }

  /**
   * 1. 匿名ユーザ
   * 2. サインアップ済み
   * 3. 未サインアップ
   */
  let userData
  if (isAnonymous) {
    /* 匿名ユーザ */
    if (location.hostname !== DOMAIN_NAME) { console.log('beforeEach(): Anonymous User') }
    userData = getAnonymousData()
  } else {
    /* サインイン */
    if (location.hostname !== DOMAIN_NAME) { console.log('beforeEach(): Sign-in') }
    userData = await getMyUserData(userId)
    if (location.hostname !== DOMAIN_NAME) { console.log(`beforeEach() Sign-in userData: ${JSON.stringify(userData)}`) }
    if (userData.isAnonymous) {
      /* サインアップしていない */
      console.log('beforeEach(): Sign-up')
      userData = await signUpQnQ(user)
      if (location.hostname !== DOMAIN_NAME) { console.log(`beforeEach() Sign-up userData: ${JSON.stringify(userData)}`) }
    }
  }

  if (location.hostname !== DOMAIN_NAME) { console.log(`beforeEach(): userData: ${JSON.stringify(userData)}`) }

  Store.commit('setUserData', userData)
  Store.commit('setIsLoggingIn', false)

  if (!to.name) {
    if (location.hostname !== DOMAIN_NAME) { console.log('routerが失敗') }
    next({path: '/'})
  }

  /*
   * 特殊ルーティング
   *   招待メールの招待リンクから飛んできた時のルーティング
   */
  if (to.name === 'Join') {
    next()
  }

  /*
   * 通常ルーティング
   *   匿名ログインユーザー -> next()
   *   ログイン済みユーザー -> next()
   *   treeページなどからログイン画面に飛んでログインしたユーザー -> 元見ていたページ(viewingPage)
   *     viewingPage はモーダルからログイン画面に飛ぶタイミングで set される
   *   普通にログイン画面にいってログインしたユーザー -> /top
   */
  if (location.hostname !== DOMAIN_NAME) {
    console.log(`routing: isAnonymous ${userData.isAnonymous}, fromLogin ${Store.state.fromLogin}, viewingPage ${Store.state.viewingPage}`)
  }
  if (userData.isAnonymous) {
    if (to.matched.some(record => record.meta.isAnonymous)) {
      next()
    } else {
      next({ path: '/about' })
    }
  } else if (!Store.state.fromLogin) {
    next()
  } else if (Store.state.viewingPage) {
    const path = Store.state.viewingPage
    Store.commit('setFromLogin', false)
    Store.commit('setViewingPage', null)
    next({path: path})
  } else {
    Store.commit('setFromLogin', false)
    next({path: '/'})
  }
})

async function checkUserAuthState () {
  /* Authしたときのuserの状態を返す */
  return new Promise((resolve) => {
    onAuthStateChanged(auth, async (user) => {
      return resolve(user)
    })
  })
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js